import { Component } from '@angular/core';
import { CourseContentDisplayComponent } from '../course-content-display/course-content-display.component';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-course-content-display-webinar',
  templateUrl: './course-content-display-webinar.component.html',
  styleUrls: ['./course-content-display-webinar.component.scss']
})
export class CourseContentDisplayWebinarComponent extends CourseContentDisplayComponent {
  constructor(
    ucdService: UserCourseDataService
  ) {
    super(ucdService);
  }

  ngOnInit() {
  }

  updatePendingStatusChange(vjsValue: boolean) {
    this.pendingStatusChange.emit(vjsValue);
  }
}
